export enum actionTypes {
    JACKPOTS_EXTERNAL_FETCH = 'JACKPOTS_EXTERNAL_FETCH'
}
